import { render, staticRenderFns } from "./RiskInfo.vue?vue&type=template&id=964bddf4&scoped=true"
import script from "./RiskInfo.vue?vue&type=script&lang=js"
export * from "./RiskInfo.vue?vue&type=script&lang=js"
import style0 from "./RiskInfo.vue?vue&type=style&index=0&id=964bddf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964bddf4",
  null
  
)

export default component.exports